module.exports = __webpack_public_path__ + "images/email20c73a902d0d2b67bc42e10d67f160a5.png";